import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router';
import axios from 'axios';
import moment from 'moment';// import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from 'date-fns/locale/ja';
import Loading from '../Loading/Loading';
import { useHistory, generatePath } from 'react-router-dom';
import constClass from '../../Constants/Constants';
registerLocale('ja', ja);

const AppLottery = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [lockData, setLockData] = useState(false);
  const [masterData, setMasterData] = useState(null);
  const [customerrankData, setCustomerRankData] = useState([]);
  const { addToast } = useToasts();
  const history = useHistory();

  const refreshMaster = useCallback(async () => {
    setLockData(true);
    var resdata = null
    try {
      const jwt = localStorage.getItem('jwt');
      resdata = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/applottery/backyard/${siteId}/${mallId}`, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;      

      var reg_params = { site_id: siteId };
      const customerrankdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/search`, reg_params, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })).data;
      customerrankdata.sort((a, b) => a.point_lower - b.point_lower)
      setCustomerRankData(customerrankdata);

      resdata = {
        ...resdata,
        lottery_start: resdata.lottery_start ? moment(resdata.lottery_start, 'YYYYMMDD').toDate() : null,
        lottery_end: resdata.lottery_end ? moment(resdata.lottery_end, 'YYYYMMDD').toDate() : null,
        rank_id: resdata.app_lottery_ranks ? resdata.app_lottery_ranks.map((rank) => rank.rank_id) : [],
      }

    } catch (error) {
      resdata = null;
    }

    var data = {
      site_id: siteId,
      mall_id: mallId,
      lottery_start: resdata.lottery_start ? resdata.lottery_start : null,
      lottery_end: resdata.lottery_end ? resdata.lottery_end : null,
      lottery_title: resdata ? resdata.lottery_title : '',
      lottery_detail: resdata ? resdata.lottery_detail : '',
      rank_id: resdata ? resdata.rank_id : [],
      upd_date: resdata ? resdata.upd_date : null,
    }

    setMasterData(data);
    setLockData(false);
  }, [siteId, mallId]);

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setMasterData({ ...masterData, [name]: value });
  }

  const registerData = async () => {
    try {
      if (!masterData.lottery_start || !masterData.lottery_end || moment(masterData.lottery_start) > moment(masterData.lottery_end)) {
        window.alert('期間指定が間違っています。');
        return;
      }
      var data = {
        ...masterData,
        lottery_start: moment(masterData.lottery_start).format('YYYYMMDD'),
        lottery_end: moment(masterData.lottery_end).format('YYYYMMDD'),
        rank_id: Array.isArray(masterData.rank_id) ? [...new Set(masterData.rank_id.map(Number))] : [],
        upd_name: user.userId
      };      
      if (!window.confirm(`登録してよろしいですか？`)) {
        return;
      }
      setLockData(true);

      const jwt = localStorage.getItem('jwt');
      const res = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/applottery/backyard/${siteId}/${mallId}`, data, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      }));
      if (res && res.data && res.data.result) {
        //正常終了
        addToast(`更新完了しました。`, { appearance: 'success', autoDismiss: true });
        refreshMaster();
      } else {
        console.log(res.data)
        //異常終了
        addToast((res && res.data && res.data.msg) ? res.data.msg : "エラーが発生しました", { appearance: 'error', autoDismiss: true });
      }
    } catch (error) {
      console.log(error, user)
    } finally {
      setLockData(false);
    }
  }

    /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');

    if (!window.confirm(`抽選情報を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      mall_id: mallId,
      upd_date: masterData.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/applottery/backyard/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
      if (res && res.data && res.data.result) {
        //正常終了
        addToast(`削除しました。`, { appearance: 'success', autoDismiss: true });
        refreshMaster();
      } else {
        console.log(res.data)
        //異常終了
        addToast((res && res.data && res.data.msg) ? res.data.msg : "エラーが発生しました", { appearance: 'error', autoDismiss: true });
      }
    } catch (error) {
      console.log(error, user)
    } finally {
      setLockData(false);
    }
  }

  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  const setDateValue = (value, name) => {
    console.log(value)
    setMasterData({ ...masterData, [name]: value });
  }

  const handleRankIdChange = (e) => {
    const value = e.target.value;
    let newRankIds = Array.isArray(masterData.rank_id) ? [...masterData.rank_id] : [];
    if (e.target.checked) {
      if (!newRankIds.includes(value)) {
        newRankIds.push(value);
      }
    } else {
      newRankIds = newRankIds.filter((id) => String(id) !== String(value));
    }
    setMasterData({ ...masterData, rank_id: newRankIds });
  };

  const renderAppLotteryInfoButton = () => {
    return (
      <button type="button"
        className="btn text-black bg-lightwhite mx-1 w-auto border-black"
        onClick={() => history.push(generatePath(`${props.match.path}applotterybonus/`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }))}
      >
        ボーナス情報設定
      </button>
    )
  }

  return (
    <div className="container">
      <div className="row mx-0 my-2 px-1-env my-4">
        <div className='mx-4 h4'>抽選設定</div>
        {renderAppLotteryInfoButton()}
      </div>
      {masterData &&
        <div className="row mx-0 my-2 px-1-env">
          <div className="col-10">
            <div className="row my-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>抽選期間</span>
              </div>
              <div className="col-4 text-center">
                <DatePicker className="custom-select text-left"
                  locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id={'lottery_start'} name={'lottery_start'}
                  popperPlacement='bottom'
                  selected={masterData && masterData.lottery_start ? masterData.lottery_start : null}
                  onChange={(value) => setDateValue(value, "lottery_start")}
                  placeholderText="- 選択 -"
                  autoComplete='off'
                  isClearable={true}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
              <div className="col-1 text-center">～</div>
              <div className="col-4 text-center">
                <DatePicker className="custom-select text-left"
                  locale="ja" dateFormat="yyyyMMdd" monthsShown="1" id={'lottery_end'} name={'lottery_end'}
                  popperPlacement='bottom'
                  selected={masterData && masterData.lottery_end ? masterData.lottery_end : null}
                  onChange={(value) => setDateValue(value, "lottery_end")}
                  placeholderText="- 選択 -"
                  autoComplete='off'
                  isClearable={true}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="ticket_summary">抽選タイトル</label>
              </div>
              <div className="col-5 align-self-center">
                <textarea className="form-control" rows="3" name="lottery_title" id="lottery_title" value={masterData.lottery_title} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <label htmlFor="lottery_detail">抽選詳細</label>
              </div>
              <div className="col-5 align-self-center">
                <textarea className="form-control" rows="3" name="lottery_detail" id="lottery_detail" value={masterData.lottery_detail} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-3 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>利用可能ランクID</span>
              </div>
              <div className="col-9 d-flex align-items-center">
                {customerrankData.map((rank, index) => (
                  <div className="form-check mx-2" key={rank.rank_id}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`rank_id_${rank.rank_id}`}
                      name="rank_id"
                      value={rank.rank_id}
                      checked={masterData && Array.isArray(masterData.rank_id) && masterData.rank_id.map(String).includes(String(rank.rank_id))}
                      onChange={handleRankIdChange}
                    />
                    <label className="form-check-label mx-1" htmlFor={`rank_id_${rank.rank_id}`}>
                      {rank.rank_name}
                    </label>
                  </div>
                ))}
                <span className='ml-4'>※未選択の場合、全ランクで利用可能です。</span>
              </div>
            </div>
          </div>
          <div className='col-12'>
            <div className="row my-3 mt-4 d-flex justify-content-center">
              <div className="col-2 text-center">
                <button type="button"
                  className={`btn btn-primary mx-1 w-100 text-nowrap`}
                  disabled={lockData}
                  onClick={() => registerData()}>
                  登録</button>
              </div>
              <div className="col-2 text-center">
                <button type="button"
                  className={`btn btn-primary mx-1 w-100 text-nowrap`}
                  disabled={lockData}
                  onClick={() => handleDeleteClick()}>
                  削除</button>
              </div>
            </div>
          </div>
        </div>}

      {(lockData || !masterData) && <Loading />}
    </div>
  )
}

export default AppLottery;